import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  FormControl,
  OutlinedInput,
  Stack,
  Paper,
  Typography,
  TextField
} from '@mui/material';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDispatch, useSelector } from 'react-redux';
import { CheckPermission } from '../../hooks/userPerm';
import { useOkta } from '../../hooks/oktaHook';
import { setShowSave } from '../../redux/FeedbackCollation/feedbackCollationSlice';
import MyAutocompleteComponent from './CustomAutoComplete';
import { setEditedRows } from '../../redux/DecisionCentral/decisionCentralRulesSlice';

const MultiVotingCard = (props) => {
  const dispatch = useDispatch();
  const {
    checkedRows,
    multiVoteComponentLabels,
    parentComponent,
    getVoteData,
    resetVoteData,
    tagUsers,
    areVotesSaved,
    setAreVotesSaved,
    currentVotingTeam,
    setShowApply,
    setShowUndo,
    showApply,
    showUndo,
    isSingleSelected = false,
    showDecisonSubmit = false,
    setshowDecisonSubmit
  } = props;

  const [effectiveDate, setEffectiveDateValue] = React.useState(dayjs());
  const isThumbHovered = false;
  const [thumbStatus, setThumbStatus] = useState(false);
  const [recoName, setRecoName] = useState('');
  const [comment, setComment] = useState('');
  const [isThumbUpClicked, setIsThumbUpClicked] = useState(false);
  const [isThumbDownClicked, setIsThumbDownClicked] = useState(false);
  const skuCount = checkedRows?.length;
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [open, setOpen] = useState(false);
  const { userDetails } = useOkta();
  //disable components
  const hasMultiVotePerm = CheckPermission(userDetails, 'multi-vote');
  // check buttons
  const [showmultiplerows, setShowmultiplerows] = useState(false);

  const decisionCentralRules = useSelector((state) => state.decisionMakingCentralRules);
  const { prevEditedRows = [] } = decisionCentralRules;

  const handleComment = (e) => {
    setComment(e.target.value);
  };

  const handleThumbsUpCount = () => {
    setIsThumbUpClicked(true);
    setIsThumbDownClicked(false);

    if (!thumbStatus) {
      setThumbStatus(true);
    }
  };
  const handleThumbsDownCount = () => {
    setIsThumbDownClicked(true);
    setIsThumbUpClicked(false);

    if (thumbStatus) {
      setThumbStatus(false);
    }
  };

  useEffect(() => {
    if (checkedRows?.length > 0) {
      if (currentVotingTeam === 'Steering Reco') {
        if (isThumbUpClicked) {
          setShowApply(false);
        }
        if (isThumbDownClicked) {
          if (recoName && comment) {
            setShowApply(false);
          } else {
            setShowApply(true);
          }
        }
      } else if (
        currentVotingTeam === 'Functional Feedback' ||
        currentVotingTeam === 'Regional Decisions'
      ) {
        if (isThumbUpClicked) {
          setShowApply(false);
        } else {
          setShowApply(true);
        }
        if (isThumbDownClicked) {
          if (comment) {
            setShowApply(false);
          } else {
            setShowApply(true);
          }
        }
      } else if (parentComponent === 'Decision') {
        if (recoName && effectiveDate) {
          setshowDecisonSubmit(false);
        } else {
          setshowDecisonSubmit(true);
        }
      } else if (parentComponent === 'Completion Status') {
        if ((isThumbUpClicked || isThumbDownClicked) && effectiveDate) {
          setshowDecisonSubmit(false);
        } else {
          setshowDecisonSubmit(true);
        }
      } else {
        setShowApply(true);
        setShowUndo(true);
      }
    }
  }, [
    parentComponent,
    currentVotingTeam,
    isThumbUpClicked,
    isThumbDownClicked,
    recoName,
    comment,
    checkedRows,
    selectedOptions
  ]);

  const handleRecoName = (recoValue) => {
    setRecoName(recoValue);
  };

  const handleVote = () => {
    const voteData = {
      skuCount,
      thumbStatus,
      recoName,
      comment,
      selectedOptions,
      effectiveDate
    };
    setShowUndo(false);
    dispatch(setShowSave(false));
    getVoteData(voteData, checkedRows);
  };

  // Function to reset all states for undo button
  const resetVotes = () => {
    setComment('');
    setIsThumbUpClicked(false);
    setIsThumbDownClicked(false);
    setThumbStatus(false);
    setRecoName('');
    setSelectedOptions([]);
    setInputValue('');
    resetVoteData();
    setShowApply(true);
    setShowUndo(true);
    dispatch(setShowSave(true));
    dispatch(setEditedRows(prevEditedRows));
  };

  // useffect for reseting after save button
  useEffect(() => {
    if (areVotesSaved) {
      resetVotes();
      setAreVotesSaved(false);
    }
  }, [areVotesSaved]);

  const handleInput = (event, newValue) => {
    setInputValue(newValue);

    setOpen(
      newValue.length > 0 &&
        tagUsers.some((option) => option.UserName.toLowerCase().includes(newValue.toLowerCase()))
    );
  };

  const handleChange = (event, newValue) => {
    if (isSingleSelected) {
      setSelectedOptions([newValue?.[newValue?.length - 1]]);
    } else {
      setSelectedOptions(newValue);
    } // Update selected options
  };

  const handleClear = () => {
    setSelectedOptions([]); // Open the dropdown when the input field is focused
  };

  return (
    <Paper
      id="multi-vote"
      style={{
        height: '135px',
        background: '#fff',
        alignItems: 'center',
        margin: '20px',
        width: '100%',
        direction: 'row',
        display:
          (parentComponent === 'Voting' ||
            parentComponent === 'Decision' ||
            parentComponent === 'Completion Status') &&
          !hasMultiVotePerm?.['multi-vote']
            ? 'flex'
            : 'none'
      }}>
      <Stack style={{ width: parentComponent === 'Voting' ? '25%' : '20%' }}>
        <FormControl
          id="typo-vote"
          variant="outlined"
          sx={{ margin: '10px 10px 10px 10px', width: '30%' }}>
          <Typography variant="body2" sx={{ whiteSpace: 'nowrap', fontWeight: '700' }}>
            {multiVoteComponentLabels.title}
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
            {checkedRows?.length} SKUs selected
          </Typography>
        </FormControl>
      </Stack>
      <Stack
        sx={{
          width: parentComponent === 'Voting' ? '75%' : '80%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '10px'
        }}>
        {/* This is Voting screen recommendation */}
        {(parentComponent === 'Voting' || parentComponent === 'Completion Status') && (
          <FormControl variant="outlined" sx={{ margin: '10px' }}>
            <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
              {parentComponent === 'Completion Status'
                ? 'Completion Status'
                : currentVotingTeam === 'Steering Reco'
                  ? 'Agree Action Reco'
                  : 'Agree Steering Team Reco'}
            </Typography>
            <Stack direction={'row'} spacing={1}>
              <Box
                role={'button'}
                sx={{
                  border: '1px solid #D7E5F8',
                  width: '54px',
                  height: '32px',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  borderRadius: '3px',
                  backgroundColor: isThumbUpClicked ? '#005CBC' : '#EFF5FC'
                }}
                onClick={handleThumbsUpCount}>
                <ThumbUpOffAltIcon
                  data-testid="ThumbUpOffAltIcon"
                  style={{
                    color: isThumbUpClicked ? '#fff' : isThumbHovered ? '#fff' : '#005CBC'
                  }}
                />
              </Box>
              <Box
                role={'button'}
                sx={{
                  border: '1px solid #D7E5F8',
                  width: '54px',
                  height: '32px',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  borderRadius: '3px',
                  backgroundColor: isThumbDownClicked ? '#005CBC' : '#EFF5FC'
                }}
                onClick={handleThumbsDownCount}>
                <ThumbDownOffAltIcon
                  data-testid="ThumbDownOffAltIcon"
                  style={{
                    color: isThumbDownClicked ? '#fff' : isThumbHovered ? '#fff' : '#005CBC'
                  }}
                />
              </Box>
            </Stack>
          </FormControl>
        )}

        {/* DropDown Element */}
        {currentVotingTeam === 'Functional Feedback' ? (
          <div></div>
        ) : (
          multiVoteComponentLabels?.dropdown && (
            <FormControl variant="outlined" sx={{ margin: '10px' }}>
              <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                {multiVoteComponentLabels.dropdown}
              </Typography>
              <OutlinedInput
                id="reco-vote"
                onChange={(e) => {
                  const recoinput = e.target.value;
                  const sanitizedValue = recoinput.replace(/[^a-zA-Z0-9 ]/g, '');
                  handleRecoName(sanitizedValue);
                }}
                value={recoName}
                placeholder="Input Recommendation"
                onMouseLeave={() => {
                  setShowmultiplerows(false);
                }}
                inputProps={{
                  maxLength: 24
                }}
                onMouseEnter={() => setShowmultiplerows(true)}
                multiline={showmultiplerows ? true : false}
                style={{
                  padding: '5px',
                  width: '185px',
                  height: showmultiplerows ? 'auto' : '32px',
                  fontSize: '14px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              />
            </FormControl>
          )
        )}

        {(parentComponent === 'Decision' || parentComponent === 'Completion Status') && (
          <FormControl variant="outlined" sx={{ margin: '10px' }}>
            <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
              {multiVoteComponentLabels.date}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={effectiveDate}
                onChange={(newValue) => setEffectiveDateValue(newValue)}
                renderInput={(params) => <TextField {...params} />}
                sx={{
                  // padding: '5px',
                  width: '160px',
                  height: '32px',
                  fontSize: '14px',
                  '& input': { padding: '5px' } // Specific input styling
                }}
              />
            </LocalizationProvider>
          </FormControl>
        )}

        {parentComponent === 'Decision' || parentComponent === 'Completion Status' ? (
          <>
            {currentVotingTeam === 'Regional Decisions' ? (
              <div></div>
            ) : (
              multiVoteComponentLabels.inputFrom && (
                <FormControl variant="outlined" sx={{ margin: '10px' }}>
                  <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                    {multiVoteComponentLabels.inputFrom}
                  </Typography>

                  <MyAutocompleteComponent
                    userOptions={tagUsers}
                    setSelectedOptions={setSelectedOptions}
                    selectedOptions={selectedOptions}
                    setInputValue={setInputValue}
                    inputValue={inputValue}
                    setOpen={setOpen}
                    handleInput={handleInput}
                    handleChange={handleChange}
                    handleClear={handleClear}
                  />
                </FormControl>
              )
            )}
            <FormControl variant="outlined" sx={{ margin: '10px' }}>
              <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                {multiVoteComponentLabels.comment}
              </Typography>
              <OutlinedInput
                id="comment-vote"
                onChange={handleComment}
                value={comment}
                placeholder="Input Comment"
                onMouseLeave={() => {
                  setShowmultiplerows(false);
                }}
                inputProps={{ maxLength: 100 }}
                onMouseEnter={() => setShowmultiplerows(true)}
                multiline={showmultiplerows ? true : false}
                style={{
                  padding: '5px',
                  width: '185px',
                  height: showmultiplerows ? 'auto' : '32px',
                  fontSize: '14px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              />
            </FormControl>
          </>
        ) : (
          <>
            <FormControl variant="outlined" sx={{ margin: '10px' }}>
              <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                {multiVoteComponentLabels.comment}
              </Typography>
              <OutlinedInput
                id="comment-vote"
                onChange={handleComment}
                value={comment}
                placeholder="Input Comment"
                onMouseLeave={() => {
                  setShowmultiplerows(false);
                }}
                inputProps={{ maxLength: 100 }}
                onMouseEnter={() => setShowmultiplerows(true)}
                multiline={showmultiplerows ? true : false}
                style={{
                  padding: '5px',
                  width: '185px',
                  height: showmultiplerows ? 'auto' : '32px',
                  fontSize: '14px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              />
            </FormControl>
            {currentVotingTeam === 'Regional Decisions' ? (
              <div></div>
            ) : (
              multiVoteComponentLabels.inputFrom && (
                <FormControl variant="outlined" sx={{ margin: '10px' }}>
                  <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                    {multiVoteComponentLabels.inputFrom}
                  </Typography>

                  <MyAutocompleteComponent
                    userOptions={tagUsers}
                    setSelectedOptions={setSelectedOptions}
                    selectedOptions={selectedOptions}
                    setInputValue={setInputValue}
                    inputValue={inputValue}
                    setOpen={setOpen}
                    handleInput={handleInput}
                    handleChange={handleChange}
                    handleClear={handleClear}
                  />
                </FormControl>
              )
            )}
          </>
        )}

        <Button
          data-testid="apply-button"
          variant="contained"
          color="primary"
          size="medium"
          disabled={
            ['Decision', 'Completion Status'].includes(parentComponent)
              ? showDecisonSubmit || checkedRows.length === 0
              : (multiVoteComponentLabels.buttonLabel === 'Apply Votes' && showApply) ||
                  checkedRows?.length === 0
                ? true
                : false
          }
          // eslint-disable-next-line max-len
          style={{
            height: '32px',
            width: parentComponent === 'Voting' ? '128px' : '152px',
            marginTop: '12px',
            marginLeft: '12px'
            // margin: '23px 10px 0 100px'
          }}
          onClick={handleVote}>
          {multiVoteComponentLabels.buttonLabel}
        </Button>
        {['Voting', 'Decision', 'Completion Status'].includes(parentComponent) && (
          <Button
            data-testid="undo-button"
            variant="contained"
            color="primary"
            size="medium"
            disabled={showUndo || checkedRows?.length === 0} // only enabled when apply is clicked
            // eslint-disable-next-line max-len
            style={{
              height: '32px',
              width: '128px',
              marginTop: '12px'
            }}
            onClick={resetVotes}>
            Undo Votes
          </Button>
        )}
      </Stack>
    </Paper>
  );
};

export default MultiVotingCard;
